import { createContext } from "react";
import type { PermissionService } from "./permissionServiceCore";

export const PermissionServiceContext = createContext<PermissionService | null>(null);
